import React from "react";
import Container from "@material-ui/core/Container";
import { CardMedia, Grid } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { styles } from "./styles";

const useStyles = makeStyles(() => createStyles(styles));

type Props = {
  title: string;
  logo: string;
  logOutUser: () => void;
};

const Header = ({ logOutUser }: Props) => {
  const classes = useStyles();

  return (
    <div>
      <div className={classes.root}>
        <Container>
          <Grid container direction="row" justify="flex-start" alignItems="center">
            <Grid item xs={8} sm={8} className={classes.logoContainer}>
              <div className={classes.logo}>
                <CardMedia component="img" alt="logo" image="assets/logo-complete.svg" style={{ width: "200%" }} />
              </div>
            </Grid>
            <Grid item xs={4} sm={4} className={classes.containerLogOut} onClick={() => logOutUser()}>
              <CardMedia className={classes.iconLogoLogOut} component="img" image="assets/icons/ic_logout.png" />
              <span className={classes.logOutText}>Cerrar sesi&oacute;n</span>
            </Grid>
          </Grid>
        </Container>
      </div>
    </div>
  );
};

export default Header;
